import React, { StrictMode } from 'react';
import { ApolloProvider } from '@apollo/client';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { initializeApp } from 'firebase/app';
import store from 'redux/store';
import client from 'graphql/client';
import Root from 'components/Root/Root';
import { firebaseConfig } from 'constants/firebase';
import { firebaseRegistration } from 'helpers/firebase';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './assets/css/index.css';

initializeApp(firebaseConfig);

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <ApolloProvider client={client}>
        <Root />
      </ApolloProvider>
    </Provider>
  </StrictMode>,
  document.getElementById('root'),
);

// Dev tools util
reportWebVitals();

// Service worker
serviceWorkerRegistration.register({
  onSuccess: firebaseRegistration,
  onUpdate: firebaseRegistration,
});
